<template>
  <div v-if="isAdmin">
    <h3>{{$t('launch.tab.control.heading.show_in_marketplace')}}</h3>
    <cvt-switch
      size="sm"
      color="active"
      type="circular"
      description-type="default"
      :initial-state="marketplace"
      :mode="mode"
      @switchToggle="onSwitchToggle"
    />
  </div>
</template>

<script>
import * as getters from '../../../../store/modules/getters'
import * as actions from '../../../../store/modules/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      mode: 'LIGHT'
    }
  },
  computed: {
    ...mapGetters({
      site: getters.SITE_GET_DATA,
      isAdmin: getters.AUTH_GET_USER_IS_ADMIN
    }),
    marketplace: {
      get () {
        return this.site.marketplace
      },
      set (enabled) {
        return this.enableMarketplace({
          id: this.site.id,
          enabled
        })
      }
    }
  },
  methods: {
    ...mapActions({
      enableMarketplace: actions.SITE_ENABLE_MARKETPLACE
    }),
    onSwitchToggle () {
      this.marketplace = !this.marketplace
    }
  }
}
</script>

<style lang="scss">
</style>
